import React from 'react';
import c from 'classnames';
import i18next from 'i18next';
import Immutable from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';

const ParagraphChapter = (props) => {
  const {
    entity,
    index,
    className,
  } = props;

  const paragraph = entity.toJS();
  const classNames = c('ParagraphChapter', className);

  const title = paragraph.field_chapter_title[0].value;
  const sections = paragraph.field_section;

  const chapterTitle = i18next.t('paragraph.chapter.title', { number: index + 1, title });

  return (
    <article className={classNames}>
      <h2>{chapterTitle}</h2>

      {sections.length > 0 && (
        <div className="ParagraphChapters__sections">
          {sections.map((section) => {
            const targetId = section.target_id;
            const language = section.entity.langcode[0].value;
            const id = `paragraph:${targetId}:${language}`;

            return (
              <Paragraph
                key={id}
                id={id}
                entity={Immutable.fromJS(section.entity)}
              />
            );
          })}
        </div>
      )}
    </article>
  );
};

export default ParagraphChapter;
